import { useCallback, useEffect, useState } from 'react'

import { useDataBoxSelector, subscibeTo } from 'app/common/data-box-store'
import { PlainRadioGroup } from 'app/common/ui-next/plain-radio-button'

import {
  orderByClassesGroupFilter,
  orderByClassesGroupFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = {
  id: string
  pending: boolean
  visibleFromBox: string
}

export const OrderByClassesDetailsGroupFilter = ({ id, pending, visibleFromBox }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)

  const data = useDataBoxSelector(orderByClassesGroupFilter, () => orderByClassesGroupFilter.data)
  const current = useDataBoxSelector(
    orderByClassesGroupFilterSelection,
    () => orderByClassesGroupFilterSelection.data,
  )

  const handleChange = useCallback((value: string) => {
    orderByClassesGroupFilterSelection.updateData(() => value)
  }, [])

  useEffect(() => {
    const unsubsribe = subscibeTo<boolean>(visibleFromBox, setFilterVisibility)
    return unsubsribe
  }, [visibleFromBox])

  return (
    filterVisibility && (
      <PlainRadioGroup
        id={id}
        label="Группировать по"
        items={data}
        current={current}
        disabled={pending}
        onChange={handleChange}
        keepPadding
      />
    )
  )
}
